<template>
  <div class="card border-0">
    <h5 class="card-header bg-primary text-white">Consistency Score</h5>
    <div class="card-body p-0">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="w-50">Consistency Score</td>
            <td class="d-none d-sm-none d-md-table-cell">
              <h3>{{ consistency.score }}%</h3>
            </td>
            <td class="d-md-none d-lg-none" :class="getBgClass(consistency.score)">
              <h3>{{ consistency.score }}%</h3>
            </td>
            <td class="w-50 d-none d-sm-none d-md-table-cell">
              <div class="progress">
                <div
                  class="progress-bar"
                  :class="getBgClass(consistency.score)"
                  role="progressbar"
                  :style="{ width: consistency.score + '%' }"
                  :aria-valuenow="consistency.score"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
                <div class="progress-bar bg-secondary" role="progressbar" style="width: 5%" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100">
                  {{ consistency.score }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ConsistencyChart
      :isLoading="isLoading"
      :organizationId="organizationId"
      :reportId="reportId"
      :report="report"
      class="border-left border-right border-bottom"
    />
  </div>
</template>

<script>
import ConsistencyChart from "@/views/reports/report/edit-report/ConsistencyChart.vue";

export default {
  components: {
    ConsistencyChart,
  },
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,
  },
  computed: {
    consistency() {
      return this.report ? this.report.consistency || {} : {};
    },
  },
  methods: {
    getBgClass(value) {
      if (!value) return ["bg-secondary", "text-white"];
      if (value >= 90) return ["bg-success", "text-white"];
      if (value >= 80) return ["bg-warning", "text-white"];
      return ["bg-danger", "text-white"];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

table {
  @extend .mb-0;

  th,
  td {
    @extend .text-center;

    h3,
    h4,
    h5 {
      @extend .mb-0;
    }
  }
}

.progress {
  @extend .mt-2;
  height: 19px;
}
</style>
